import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { SessionHelper } from '../../shared/services/localstorage';
import { LoggedinService } from '../login/loggedin.service';
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    path: ActivatedRouteSnapshot[];
    route: ActivatedRouteSnapshot;
    constructor(private router: Router, private loggedinService: LoggedinService) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (SessionHelper.isLoggedIn() && next.data.isRouteAccess) {
            return true;
        } else {
            this.router.navigate(['']);
            return false;
        }
    }
}
